<template>
    <div class="title">
        <span></span>
        <slot></slot>
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.title {
    color: $color-n10;
	font-size: 16px;
	font-weight: 700;
    margin-bottom: 12px;
	display: flex;
	font-family: $font-family85;
	align-items: center;
	span {
		width: 5px;
		height: 16px;
		background: $color-b4;
		margin-right: 8px;
	}
}
</style>